// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://jdwcgbwcwkrrvaqtokju.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impkd2NnYndjd2tycnZhcXRva2p1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI4MzE5ODYsImV4cCI6MjA0ODQwNzk4Nn0.WRbMpo-G6qhRa0vMKHbdi5GHyRzvYslXBdnJ5Ebw9pA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});